import Vue from "vue"
import { AppVersion, DEFAULT_PACKAGE_CODE, PayOrderTypes, Tags } from "../constant"
import { kStorageUrl } from "@/models/PSDLayer"
import router from "../routes"
import dayjs from "dayjs"
import axios from "../api/restApi"
import authService from "../api/auth-service"
import i18n from "../i18n"
import storage from "@/methods/storage.js"

export const tossInit = ({ commit }, payload) => {
  let recaptchaScript = document.createElement("script")
  recaptchaScript.setAttribute("src", "https://js.tosspayments.com/v1")
  document.head.appendChild(recaptchaScript)
}

export const login = async ({ commit }, payload) => {
  // JWT 로그인 처리 (userId 또는 user_id, password가 있는 경우)
  const user_id = payload.userId || payload.user_id
  if (user_id && payload.password) {
    try {
      const response = await authService.login(user_id, payload.password)

      if (response.success) {
        commit("SET_ACCESS_TOKEN", response.accessToken)
        // JWT 사용자 정보를 lafia_user에 저장
        commit("UPDATE_JWT_USER_INFO", response.user)
        // 기존 login mutation도 호출 (하위 호환)
        commit("login", {
          user_id: response.user.user_id,
          name: response.user.name,
          phone: response.user.phone || "",
          email: response.user.email || "",
          profile_image: response.user.profile_image || "default.png",
          type: response.user.provider_type === "email" ? "EMAIL" : "SNS",
          status: "",
          created: "",
          id: response.user.id,
          userType: response.user.userType,
        })
        return response
      }

      throw new Error(response.message || "로그인에 실패했습니다.")
    } catch (error) {
      commit("CLEAR_JWT_AUTH")
      throw error
    }
  }

  // 기존 로그인 처리 (하위 호환)
  commit("login", payload)

  console.log("login action", payload)

  const { qrcode, visitQrCode, pay_qrcode, callbackUrl, event, packageEvent, proudctId } = router.currentRoute.query

  try {
    await authService.updateLastLoginAt(payload.userId)

    if (qrcode) {
      await authService.updateQrCode(payload.userId, qrcode)
    } else if (visitQrCode) {
      await authService.updatePayQrcode(payload.userId, visitQrCode)
    } else if (pay_qrcode) {
      await authService.updatePayQrcode(payload.userId, pay_qrcode)
    }
  } catch (e) {
    if (payload.errorHandler) {
      payload.errorHandler()
    }
    return
  }

  if (callbackUrl) {
    router.replace(callbackUrl)
  } else {
    router.replace("/")
  }
}

export const appVersionCheck = ({ commit, state }, payload) => {
  const realodTime = dayjs(state.app_reload_time)
  const diffMinutes = dayjs().diff(realodTime, "minute")
  const recentVersion = Number(payload)

  if (recentVersion && recentVersion > AppVersion && diffMinutes > 1) {
    console.log("app reload")
    router.go(0)
    commit("SET_APP_RELOAD_TIME", Date.now())
    return false
  }
  return true
}

export const getPromotionPrice = async ({ commit, dispatch }, payload) => {
  const result = await axios.get("/api/promotion/select/code", {
    params: {
      code: payload?.promotionCode ?? null,
      photoUse: payload?.photoUse ?? null,
    },
  })

  let defaultPrice = result.data.find((e) => e.code === "default")
  defaultPrice.printPrice = 3900

  commit("SET_DEFAULT_PRICE", defaultPrice)

  let promotionPrice = payload?.promotionCode ? result.data.find((e) => e.code == payload?.promotionCode) : null

  return { defaultPrice, promotionPrice }
}

// 사진 인화 요청
export const reqPicturePrint = async ({ commit, dispatch }, payload) => {
  const { user_id, imageUrl, conceptName, count, orderId } = payload
  const result = await axios.post("/api/print/requestPrint", {
    user_id,
    imageUrl,
    conceptName,
    count,
    order_id: orderId,
  })

  dispatch("updateUsedCoupons", {
    orderId,
    user_id,
  })

  router.replace({
    name: "printReqCompl",
  })

  return result.data
}

// 쿠폰 사용완료 처리
export const updateUsedCoupons = ({ commit, dispatch }, payload) => {
  console.log("updateUsedCoupons", payload)
  const { orderId, user_id } = payload
  if (!orderId || !user_id) {
    return
  }
  axios
    .post("/api/order/v2/orderDetail", {
      orderId,
    })
    .then((orderDetailRes) => {
      const result = orderDetailRes.data.map((e) => e.couponId).filter((x) => x)
      if (result) {
        result.forEach((couponId) => {
          axios.post("/api/coupon/useCoupon", {
            registered_coupon_id: couponId,
            user_id,
          })
        })
      }
    })
}

//결제 연동 처리
export const doPayCompleted = async ({ commit, dispatch }, payload) => {
  const { orderNo, amount, paymentKey, isAbroad } = payload

  // 주문 정보 가져오기
  const product = (
    await axios.post("/api/order/select/check_duplicate", {
      params: {
        toss_id: orderNo,
      },
    })
  ).data[0]

  const { order_list_id, user_id, type, memo, pay_status, status } = product

  // 온라인 이용권 또는 온라인 예약인 경우 toss 인 경우만.. 결제 실패 처리가 필요함 todo::

  let tossPaymentConfirm = () => {
    // 결제완료 이면서 상태완료 이면 무시
    if (pay_status === "결제완료" && status === "결제완료") {
      return { data: { status: "DONE" } }
    }

    return axios
      .post("/api/payments/toss/confirm", {
        orderListId: order_list_id,
        paymentKey: paymentKey,
        orderId: orderNo,
        amount: Number(amount),
      })
      .catch(async (e) => {
        if (e.response.data.code === "ALREADY_PROCESSED_PAYMENT") {
          console.log("toss confirm ALREADY_PROCESSED_PAYMENT")
          // 이미 결제된 사항.
          return { data: { status: "DONE" } }
        } else {
          const errorMessage = e.response.data || "Unknown Error"
          await dispatch("cancelPayStatusUpdate", {
            order_id: order_list_id,
            reason: JSON.stringify(errorMessage),
          })
        }
        throw e
      })
  }

  let testTossPaymentConfirm = () => {
    return new Promise((resolve, reject) => {
      resolve({ data: { status: "DONE" } })
    })
  }

  let payletterConfirm = () => {
    return new Promise((resolve, reject) => resolve({ data: { status: "DONE" } }))
  }

  let payConfirmAsync = !isAbroad ? (paymentKey === "test" ? testTossPaymentConfirm : tossPaymentConfirm) : payletterConfirm

  let payConfirmResultData = (await payConfirmAsync()).data
  if (payConfirmResultData.status != "DONE") {
    alert(i18n.t("alert.error_doing_pay_unknown_error"))
    return
  }
  if ([PayOrderTypes.OnlineConceptBuy, PayOrderTypes.OnlineAddShot].includes(product.type)) {
    // 키오스크 연동 온라인 결제
    const result = await axios.post("/api/qrcode/pay/complete", {
      pay_amount: Number(amount),
      orderListId: order_list_id,
      currency: "KRW",
    })
    if (result.data.affectedRows) {
      dispatch("updateUsedCoupons", { orderId: orderNo, user_id })
      router.push("/onlinePaySuccess?id=" + orderNo)
    }
  } else if (product.type === PayOrderTypes.OnliePhotoTouch) {
    // 추가 보정
    const result = await axios.post("/api/qrcode/update/status/byOrderId", {
      params: {
        order_id: order_list_id,
        status: "선택완료",
      },
    })
    Vue.$toast.success(i18n.t("toast.succes-photo-effect-request"))
    dispatch("updateUsedCoupons", { orderId: orderNo, user_id })
    router.push("/mypage/home?type=picture")
  } else if (product.type === PayOrderTypes.OnlinePrint) {
    // 인쇄 결제
    let info = JSON.parse(memo)
    info = {
      ...info,
      imageUrl: storage.imageUrl(`${kStorageUrl}/complete/${info.fileName}`, info.updated),
      orderId: orderNo,
    }
    const duplicateCheck = await axios.get("/api/print/getPrintHistory", {
      params: {
        order_id: orderNo,
      },
    })

    if (duplicateCheck.data.length > 0) {
      alert(i18n.t("alert.error_failed_print_request_duplicate"))
      router.replace("/mypage/home?type=picture")
      return
    }

    dispatch("reqPicturePrint", info)
  } else {
    // 예약 결제 ( 드레스 예약, 패키지 구매 )
    /*
    let tossTimeCheckAsync = () => {
      return axios.post("/api/reservation/select/specific/time/castle/check", {
        params: {
          year: product.year,
          month: product.month,
          day: product.day,
          time: product.time,
        },
      })
    }

    let payLetterTimecheck = () => {
      return new Promise((resolve, reject) => resolve({ data: { status: "DONE" } }))
    }
    let precheck = !isAbroad ? tossTimeCheckAsync : payLetterTimecheck
    const availableRoomsChceckRes = await precheck().data

    if (availableRoomsChceckRes.length > 0) {
      if (product.cloth + availableRoomsChceckRes.total_cloth > 15) {
        alert(i18n.t("alert.error_max_reservation_error"))
        router.replace("/")
        return
      }
    } */

    dispatch("updateUsedCoupons", { orderId: orderNo, user_id })
    router.push("/reservation/complete?id=" + orderNo)
  }

  //결제완료
  Vue.$gtag.purchase({
    transaction_id: orderNo,
    value: Number(amount),
    currency: "KRW",
    items: [
      {
        item_name: type,
        price: Number(amount),
      },
    ],
  })
}

export const loadConcepts = async ({ commit, dispatch }, payload) => {
  console.log("loadConcepts")
  const concepts = (await axios.post("/api/concept/select")).data
  commit("SET_CONCEPTS", concepts)
  return concepts
}

export const loadOperationTime = async ({ commit, dispatch }, payload) => {
  console.log("loadOperationTime")
  const time_info = (await axios.get("/api/operation_time/select")).data[0]
  commit("SET_OPERATION_TIME", time_info)
  return time_info
}

export const loadIndividualOperationTime = async ({ commit, dispatch }, promotionCode) => {
  console.log("loadIndividualOperationTime")
  try {
    if (!promotionCode) {
      return null
    }

    const response = await axios.get("/api/individual_operation_time/select/promotionCode", {
      params: {
        promotionCode: promotionCode,
      },
    })

    const individual_time_info = response.data

    // 데이터가 없거나 빈 배열인 경우 null 반환
    if (!individual_time_info || individual_time_info.length === 0) {
      return null
    }

    // 첫 번째 결과 반환 (최신 created 순으로 정렬되어 있음)
    return individual_time_info[0]
  } catch (error) {
    console.error("loadIndividualOperationTime error:", error)
    return null
  }
}

export const loadConceptsAll = async ({ commit, dispatch }, payload) => {
  console.log("loadConceptsAll")
  const concepts = (
    await axios.post("/api/concept/select/search", {
      params: {
        keyword: "",
      },
    })
  ).data
  return concepts
}

export const loadConceptsWithProductType = async ({ commit, dispatch }, payload) => {
  console.log("loadConceptsWithProductType", payload)
  const concepts = (
    await axios.post("/api/concept/select/list", {
      params: {
        productType: payload?.productType,
      },
    })
  ).data
  return concepts
}

export const cancelPayStatusUpdate = async ({ commit, dispatch }, payload) => {
  const res = await axios.post("/api/order/update/status", {
    params: {
      status: "결제취소",
      reason: payload.reason || "사용자취소",
      id: payload.order_id,
    },
  })
  return res
}

// ==================== JWT 인증 Actions ====================

/**
 * 로그아웃 (JWT + 기존)
 */
export const logout = async ({ commit }) => {
  try {
    await authService.logout()
  } catch (error) {
    console.error("로그아웃 에러:", error)
  } finally {
    // JWT 인증 상태 초기화
    commit("CLEAR_JWT_AUTH")

    // 기존 Vuex 로그인 상태도 초기화 (하위 호환)
    commit("logout")
  }
}

/**
 * 토큰 갱신
 */
export const refreshAccessToken = async ({ commit, state }) => {
  // 이미 갱신 중이면 기존 Promise 반환
  if (state.isRefreshing && state.refreshPromise) {
    return state.refreshPromise
  }

  commit("SET_IS_REFRESHING", true)

  const refreshPromise = authService
    .refreshToken()
    .then(async (response) => {
      if (response.success) {
        commit("SET_ACCESS_TOKEN", response.accessToken)
        // 토큰 갱신 후 사용자 정보도 업데이트
        try {
          const verifyResponse = await authService.verifyToken()
          if (verifyResponse.success && verifyResponse.user) {
            commit("UPDATE_JWT_USER_INFO", verifyResponse.user)
          }
        } catch (error) {
          console.warn("토큰 갱신 후 사용자 정보 업데이트 실패:", error)
        }
        return response.accessToken
      }
      throw new Error("토큰 갱신 실패")
    })
    .catch((error) => {
      commit("CLEAR_JWT_AUTH")
      throw error
    })
    .finally(() => {
      commit("SET_IS_REFRESHING", false)
      commit("SET_REFRESH_PROMISE", null)
    })

  commit("SET_REFRESH_PROMISE", refreshPromise)
  return refreshPromise
}
